
export function getUser() {
    let userdata = {};
    let item = localStorage.getItem('user');
    let autologin = false;
    if (item && item !== 'undefined') {
        let user = JSON.parse(item);
        if (user && user.token) {
            userdata = user;
            autologin = true;
        }
    }

    //セッションからTOKEN取得
    if (!autologin) {
        item = sessionStorage.getItem("user");
        if (item && item !== 'undefined') {
            let user = JSON.parse(item);
            if (user && user.token) {
                userdata = user;
            }
        }
    }
    return userdata;
}

export function checkUser() {
    const user = getUser();
    return (user && user.token);
}

export function authHeader() {
    // return authorization header with jwt token
    const user = getUser();
    if (user && user.token) {
        return { 
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + user.token 
        };
    } else {
        return {};
    }
}

export function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    let setValue = value;
    if ( (value === undefined) || (value === null) ) {
        setValue = "";
    }
    document.cookie = name + "=" + (setValue)  + expires + "; path=/";
}

export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

export function delete_cookie(name) {
    document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
}